import React from 'react';

import { Heading, Icon, Stack } from '@eluve/components';

export interface OutputParsingErrorProps {}

export const OutputParsingError: React.FC<OutputParsingErrorProps> = () => {
  return (
    <div className="grid h-128 w-full place-items-center">
      <Stack className="p-2" fullWidth={false} gap={2} align="center">
        <Icon
          name="AlertCircle"
          size="xl"
          className="size-10 text-bg-orange-strong"
        />
        <div>
          <Heading size="3xl">
            There was a problem generating this output
          </Heading>
        </div>
      </Stack>
    </div>
  );
};
